import { call, put } from "redux-saga/effects";
import { instructorCourseApi } from "@services/api";
import { getDiscountsActions } from "../slices";

function* getDiscountsWorker({ payload }) {
  try {
    yield put(getDiscountsActions.pending());
    const response = yield call(instructorCourseApi.getDiscounts, payload);
    yield put(getDiscountsActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getDiscountsActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getDiscountsWorker };
